var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDavaFoods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 344.96 109.62",
    style: {
      enableBackground: "new 0 0 344.96 109.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#849938;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.91,22.79C341.24,15.4,343.8,4.46,344.96,0c-2.89,3.98-9.35,6.39-13.5,7.4c-3.78,0.92-11.1,1.93-18.09,5.3 c-6.95,3.35-9.73,9.03-11.77,13.37c-2.24,4.77-3.49,12.29-3.49,12.29C306.21,28.98,311.52,28.08,323.91,22.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.01,30.52c-17.33,7.4-19.9,18.34-21.06,22.8c2.89-3.99,9.35-6.39,13.5-7.4c3.78-0.92,11.1-1.93,18.09-5.3 c6.95-3.35,9.73-9.03,11.77-13.37c2.24-4.77,3.49-12.3,3.49-12.3C333.7,24.34,328.4,25.24,316.01,30.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,52.8c-5.22,0-13.38,0.18-18.9,0.78l-1.32,7.14c1.74,0.12,3.66,0.36,5.04,0.6L0,93.48 c3.96,0.24,7.86,0.36,12.96,0.36c16.5,0,25.14-12.66,25.14-26.52C38.1,56.82,31.26,52.8,21.3,52.8z M14.58,84.18 c-0.84,0-1.56-0.06-2.04-0.18l4.14-21.66c0.84-0.12,1.5-0.12,3.24-0.12c4.8,0,6.48,2.1,6.48,6.12 C26.4,73.38,23.88,84.18,14.58,84.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.08,53.04l-20.64,40.5h11.1l3.24-6.6h12.24l0.84,6.6H73.5l-5.88-40.5H55.08z M53.04,78.18l2.16-4.44 c1.32-2.7,2.52-5.34,3.42-7.68h0.12c0.06,2.52,0.3,4.68,0.6,7.02l0.6,5.1H53.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.46,53.04L94.8,72.72c-1.8,3.72-2.4,5.28-3.36,7.8h-0.12c-0.06-2.76-0.24-5.04-0.48-7.2l-2.28-20.28H77.1 l5.4,40.5h12.84l20.58-40.5H104.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.16,53.04l-20.64,40.5h11.1l3.24-6.6h12.24l0.84,6.6h11.64l-5.88-40.5H125.16z M123.12,78.18l2.16-4.44 c1.32-2.7,2.52-5.34,3.42-7.68h0.12c0.06,2.52,0.3,4.68,0.6,7.02l0.6,5.1H123.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.42,62.64h11.7l1.86-9.6h-11.94c-5.7,0-11.04,0-16.02,0.54l-1.32,7.14c1.74,0.12,3.66,0.36,5.04,0.6 l-6.12,32.22h10.92l2.88-15.18h11.04l1.8-9.18h-11.04L177.42,62.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.24,63c-9.36,0-18.9,7.08-18.9,20.4c0,6.6,3.12,10.86,12.66,10.86c9.84,0,18.78-7.98,18.78-20.16 C219.78,67.74,216.66,63,207.24,63z M202.26,84.72c-2.1,0-2.7-1.38-2.7-2.94c0-3.66,1.86-9.3,6-9.3c2.22,0,2.94,1.02,2.94,3.06 C208.5,79.26,206.76,84.72,202.26,84.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.42,63c-9.36,0-18.9,7.08-18.9,20.4c0,6.6,3.12,10.86,12.66,10.86c9.84,0,18.78-7.98,18.78-20.16 C252.96,67.74,249.84,63,240.42,63z M235.44,84.72c-2.1,0-2.7-1.38-2.7-2.94c0-3.66,1.86-9.3,6-9.3c2.22,0,2.94,1.02,2.94,3.06 C241.68,79.26,239.94,84.72,235.44,84.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.36,50.22l-1.32,7.14c1.74,0.12,3.66,0.36,5.04,0.6v0.06l-0.96,5.1c-0.96-0.12-1.38-0.12-1.8-0.12 c-13.14,0-19.74,9.96-19.74,21.6c0,6.54,2.58,9.72,7.5,9.72c4.14,0,7.68-2.22,10.5-6.42h0.12c-0.84,1.98-1.32,3.78-1.68,5.7 c1.2,0.06,2.46,0.06,3.72,0.06c4.92,0,6.6-0.12,6.6-0.12s1.56-10.32,8.04-43.86C283.68,49.5,278.34,49.68,273.36,50.22z  M274.2,73.14c-0.96,4.98-5.1,11.7-7.38,11.7c-0.9,0-1.14-0.78-1.14-2.34c0-4.56,2.64-10.92,6.72-10.92c0.84,0,1.44,0.12,2.04,0.3 L274.2,73.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.28,73.56c0,6.84,5.64,7.86,5.64,10.74c0,0.9-0.78,1.44-2.46,1.44c-1.38,0-3.54-0.42-4.62-0.84l-1.8,8.82 c1.5,0.3,3.54,0.54,5.52,0.54c10.44,0,14.76-5.82,14.76-10.86c0-6.3-5.88-8.76-5.88-10.92c0-1.02,0.78-1.5,2.7-1.5 c1.02,0,2.22,0.18,3.3,0.48l1.98-8.1c-1.5-0.24-3.24-0.36-4.92-0.36C294.84,63,290.28,67.62,290.28,73.56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDavaFoods);
export default __webpack_public_path__ + "static/media/DAVA_Foods.0fc0bcb63e5fdc04d9ace0e834082258.svg";
export { ForwardRef as ReactComponent };